/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Form } from '@mairistem/composants';

const isDrapeauActif = (value: unknown): boolean =>
  value === 1 || value === true || value === '1';

interface CommuneDelegueFieldProps {
  /** Libellé de la commune déléguée. */
  libelle?: string | number | null;
  /** Drapeau « commune déléguée » (booléen ou smallint selon la source). */
  drapeau?: unknown;
  disabled?: boolean;
  'data-testid': string;
  onChange: (libelle: string, drapeau: boolean) => void;
}

/**
 * Case « Commune déléguée » suivie de son libellé, comme dans l'assistant :
 * le champ n'est saisissable que si la case est cochée, et décocher la case
 * vide le libellé.
 */
const CommuneDelegueField = (props: CommuneDelegueFieldProps) => {
  const { drapeau, disabled, onChange } = props;
  const testId = props['data-testid'];
  const libelle = props.libelle == null ? '' : String(props.libelle);

  // Le drapeau seul n'est pas fiable (souvent à 0 sur les données reprises) :
  // la case est aussi cochée dès qu'un libellé est enregistré.
  const checked = isDrapeauActif(drapeau) || libelle !== '';

  const handleCheck = React.useCallback(
    (_e: React.FormEvent<HTMLInputElement>, data: { checked?: boolean }) => {
      const coche = !!data?.checked;
      onChange(coche ? libelle : '', coche);
    },
    [libelle, onChange],
  );

  const handleChangeLibelle = React.useCallback(
    (_e: React.FormEvent<HTMLInputElement>, data: { value: string }) => {
      onChange(data?.value ?? '', true);
    },
    [onChange],
  );

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '1em' }}>
      <div style={{ whiteSpace: 'nowrap' }}>
        <Form.Checkbox
          label="Commune déléguée"
          data-testid={`${testId}-checkbox`}
          checked={checked}
          disabled={disabled}
          onChange={handleCheck}
        />
      </div>
      <div style={{ flex: 1 }}>
        <Form.Input
          fluid
          input={{ 'data-testid': testId }}
          value={libelle}
          disabled={disabled || !checked}
          onChange={handleChangeLibelle}
        />
      </div>
    </div>
  );
};

export default CommuneDelegueField;
